__turbopack_context__.v({
  "accountButton": "DiscoveryHeaderNav-module__kEZeXq__accountButton",
  "accountMenu": "DiscoveryHeaderNav-module__kEZeXq__accountMenu",
  "accountMenuItem": "DiscoveryHeaderNav-module__kEZeXq__accountMenuItem",
  "accountName": "DiscoveryHeaderNav-module__kEZeXq__accountName",
  "actions": "DiscoveryHeaderNav-module__kEZeXq__actions",
  "bar": "DiscoveryHeaderNav-module__kEZeXq__bar",
  "chevronOpen": "DiscoveryHeaderNav-module__kEZeXq__chevronOpen",
  "desktopNav": "DiscoveryHeaderNav-module__kEZeXq__desktopNav",
  "discoveryChromePulse": "DiscoveryHeaderNav-module__kEZeXq__discoveryChromePulse",
  "dropdown": "DiscoveryHeaderNav-module__kEZeXq__dropdown",
  "dropdownDescription": "DiscoveryHeaderNav-module__kEZeXq__dropdownDescription",
  "dropdownLabel": "DiscoveryHeaderNav-module__kEZeXq__dropdownLabel",
  "dropdownLink": "DiscoveryHeaderNav-module__kEZeXq__dropdownLink",
  "dropdownList": "DiscoveryHeaderNav-module__kEZeXq__dropdownList",
  "dropdownText": "DiscoveryHeaderNav-module__kEZeXq__dropdownText",
  "header": "DiscoveryHeaderNav-module__kEZeXq__header",
  "iconImage": "DiscoveryHeaderNav-module__kEZeXq__iconImage",
  "iconTile": "DiscoveryHeaderNav-module__kEZeXq__iconTile",
  "loading": "DiscoveryHeaderNav-module__kEZeXq__loading",
  "logo": "DiscoveryHeaderNav-module__kEZeXq__logo",
  "logoLink": "DiscoveryHeaderNav-module__kEZeXq__logoLink",
  "mobileDirectLink": "DiscoveryHeaderNav-module__kEZeXq__mobileDirectLink",
  "mobileItem": "DiscoveryHeaderNav-module__kEZeXq__mobileItem",
  "mobileItemButton": "DiscoveryHeaderNav-module__kEZeXq__mobileItemButton",
  "mobileList": "DiscoveryHeaderNav-module__kEZeXq__mobileList",
  "mobileNav": "DiscoveryHeaderNav-module__kEZeXq__mobileNav",
  "mobilePanel": "DiscoveryHeaderNav-module__kEZeXq__mobilePanel",
  "mobileSubLink": "DiscoveryHeaderNav-module__kEZeXq__mobileSubLink",
  "mobileSubList": "DiscoveryHeaderNav-module__kEZeXq__mobileSubList",
  "mobileToggle": "DiscoveryHeaderNav-module__kEZeXq__mobileToggle",
  "panelGroupLabel": "DiscoveryHeaderNav-module__kEZeXq__panelGroupLabel",
  "signIn": "DiscoveryHeaderNav-module__kEZeXq__signIn",
  "skeletonBone": "DiscoveryHeaderNav-module__kEZeXq__skeletonBone",
  "skeletonTab": "DiscoveryHeaderNav-module__kEZeXq__skeletonTab",
  "skeletonTopLink": "DiscoveryHeaderNav-module__kEZeXq__skeletonTopLink",
  "studentList": "DiscoveryHeaderNav-module__kEZeXq__studentList",
  "studentListHeading": "DiscoveryHeaderNav-module__kEZeXq__studentListHeading",
  "studentListItem": "DiscoveryHeaderNav-module__kEZeXq__studentListItem",
  "studentListItems": "DiscoveryHeaderNav-module__kEZeXq__studentListItems",
  "tab": "DiscoveryHeaderNav-module__kEZeXq__tab",
  "tabActive": "DiscoveryHeaderNav-module__kEZeXq__tabActive",
  "tabItem": "DiscoveryHeaderNav-module__kEZeXq__tabItem",
  "tabList": "DiscoveryHeaderNav-module__kEZeXq__tabList",
  "topLink": "DiscoveryHeaderNav-module__kEZeXq__topLink",
  "topLinkBar": "DiscoveryHeaderNav-module__kEZeXq__topLinkBar",
  "topLinkCurrent": "DiscoveryHeaderNav-module__kEZeXq__topLinkCurrent",
  "topLinkIcon": "DiscoveryHeaderNav-module__kEZeXq__topLinkIcon",
  "topLinkLabel": "DiscoveryHeaderNav-module__kEZeXq__topLinkLabel",
  "topLinkList": "DiscoveryHeaderNav-module__kEZeXq__topLinkList",
  "topLinkWithIcon": "DiscoveryHeaderNav-module__kEZeXq__topLinkWithIcon",
});
